<template>
    <img class="so-photo" v-bind:src="'data:image/jpeg;base64,'+src" alt="">
</template>

<script>
export default {
  name: 'SalesOrderPhoto',
  props: ['src']
}
</script>

<style scoped>
  .so-photo {
    width: 15em;
    margin: 1em;
  }
</style>
